<template>
  <header class="header" :class="{ 'scrolled': scrolled }">
    <div class="header-container">
      <div class="logo">
        <router-link to="/">
          <img src="../../assets/images/icons/logo.png" alt="矢量律动" />
          <span class="logo-text">矢量律动</span>
        </router-link>
      </div>
      <nav class="main-nav" :class="{ 'active': mobileMenuOpen }">
        <ul class="nav-links">
          <li v-for="(link, index) in navLinks" :key="index">
            <router-link :to="link.path" exact-active-class="active">{{ link.name }}</router-link>
          </li>
        </ul>
      </nav>
      <div class="contact-button">
        <router-link to="/contact" class="btn-contact">联系我们</router-link>
      </div>
      <div class="mobile-menu-toggle" @click="toggleMobileMenu">
        <span class="toggle-bar"></span>
        <span class="toggle-bar"></span>
        <span class="toggle-bar"></span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  data() {
    return {
      scrolled: false,
      mobileMenuOpen: false,
      navLinks: [
        { name: '首页', path: '/' },
        { name: '产品', path: '/products' },
        { name: '技术', path: '/technology' },
        { name: '关于我们', path: '/about' }
      ]
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 50
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
      document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : ''
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  padding: 20px 0;
  transition: all 0.3s ease;
  background: transparent;
}

.header.scrolled {
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 0;
}

.scrolled .logo-text {
  color: #3a1c71;
}

.scrolled .nav-links a {
  color: #333;
}

.scrolled .nav-links a.active,
.scrolled .nav-links a:hover {
  color: #3a1c71;
}

.scrolled .btn-contact {
  background: linear-gradient(135deg, #3a1c71, #d76d77);
  color: white;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo a {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo img {
  height: 40px;
  width: auto;
  margin-right: 10px;
  object-fit: contain;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  transition: color 0.3s ease;
}

.main-nav {
  flex: 1;
  display: flex;
  justify-content: center;
}

.nav-links {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-links li {
  margin: 0 15px;
}

.nav-links a {
  text-decoration: none;
  color: white;
  font-size: 1.1rem;
  font-weight: 500;
  padding: 5px 0;
  position: relative;
  transition: color 0.3s ease;
}

.nav-links a::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: #d76d77;
  transition: width 0.3s ease;
}

.nav-links a.active,
.nav-links a:hover {
  color: #d76d77;
}

.nav-links a.active::after,
.nav-links a:hover::after {
  width: 100%;
}

.btn-contact {
  display: inline-block;
  padding: 10px 25px;
  border: 2px solid white;
  border-radius: 30px;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-contact:hover {
  background-color: white;
  color: #3a1c71;
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 24px;
  cursor: pointer;
}

.toggle-bar {
  width: 100%;
  height: 3px;
  background-color: white;
  transition: all 0.3s ease;
  border-radius: 2px;
}

.scrolled .toggle-bar {
  background-color: #333;
}

@media (max-width: 768px) {
  .main-nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: white;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    z-index: 999;
  }
  
  .main-nav.active {
    transform: translateX(0);
  }
  
  .nav-links {
    flex-direction: column;
    align-items: center;
  }
  
  .nav-links li {
    margin: 15px 0;
  }
  
  .nav-links a {
    color: #333;
    font-size: 1.3rem;
  }
  
  .contact-button {
    display: none;
  }
  
  .mobile-menu-toggle {
    display: flex;
    z-index: 1000;
  }
  
  .main-nav.active ~ .mobile-menu-toggle .toggle-bar:nth-child(1) {
    transform: translateY(10px) rotate(45deg);
    background-color: #333;
  }
  
  .main-nav.active ~ .mobile-menu-toggle .toggle-bar:nth-child(2) {
    opacity: 0;
  }
  
  .main-nav.active ~ .mobile-menu-toggle .toggle-bar:nth-child(3) {
    transform: translateY(-10px) rotate(-45deg);
    background-color: #333;
  }
}
</style> 